/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Color/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Color({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentCard/Events/Content/Content/Content/Content/Events/Content/Compact/Past/Content/Content/NotesHeader/Notes/Content/AppointmentCell/Color"
  
}) {
let eventAppointmentTypeDisplayColorIdValueData = fromData.useDataFormat({ viewPath,
context: 'event',
path: 'appointment.type.display_color_id',
format: fromFormat.appointmentTypeColor,
})
  return (<React.Fragment
>
<div
  data-testid="Color.Horizontal"
  data-view-path={viewPath}
 style={{'--bc-1-4HDmH': eventAppointmentTypeDisplayColorIdValueData}}
 className={`views-block ${styles.Horizontal}`}
/>
{children}
</React.Fragment>)
}